var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({on:{"drop":_vm.handleDrop,"click":function($event){$event.stopPropagation();return _vm.$emit('clicked')}}},'div',_vm.$attrs,false),[_vm._t("default",null,null,_vm.$data)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }